// extracted by mini-css-extract-plugin
module.exports = {"container":"LiqpayConfigurator_container__1NQzV","kitchens":"LiqpayConfigurator_kitchens__18tpl"};